const AccountRoutes = [
	{
		path: '/accounts',
		component: () => import('@/components/default'),
		children: [
			{
				path: '',
				name: 'accounts',
				component: () => import('@/components/sales/Accounts'),
			},
			// {
			// 	path: ':id?',
			// 	name: 'warehouse-details',
			// 	component: () => import('@/components/warehouse/WareHouseDetails'),
			// },
			// {
			// 	path: ':id?/delivery/:locationId?',
			// 	name: 'warehouse-details-lines',
			// 	component: () => import('@/components/warehouse/DeliveryLines'),
			// },
			// {
			// 	path: ':id?/transfer/:transferId?',
			// 	name: 'warehouse-transfers-lines',
			// 	component: () => import('@/components/warehouse/TransferLines'),
			// },
		],
	},
];

export default AccountRoutes;
